<template>
  <div>
    <vs-popup id="add-field" :title="title" :active.sync="modalActive" @update:active="closeModal">

      <div :class="`vx-row ${index > 0 ? 'mt-5' : ''}`" v-for="(row, index) in organizedFields" :key="`row-${index}`">
        <div :class="`vx-col ${columnSize}`" v-for="(field, _index) in row" :key="`field-${_index}`">

          <template v-if="showField(field) && (NORMAL_FIELDS.includes(field.type_id))">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <text-field :type="field.secret ? 'password' : 'text'"
              :isDisabled="isFieldDisabled(field, allDisabledFields, action)" v-model="fieldValues[field.hash]"
              @focusout="handleFocusOut(field)"
              :name="field.name" :maxlength="field.length || null" :placeholder="field.placeholder"
              :cursor="field.type_id === $FIELD_TYPES.URL && !field.can_edit || field.is_disabled ? 'pointer' : 'default'" />
          </template>

          <template
            v-else-if="showField(field) && ([$FIELD_TYPES.RELATED_TO_A_MODULE, $FIELD_TYPES.PICKLIST, $FIELD_TYPES.RELATED_TO_A_USER].includes(field.type_id))">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span></label>
            <select-field :isDisabled="isFieldDisabled(field, allDisabledFields, action)" :options="field.related_parent_hash ? fieldOptions[field.hash] : field.options"
              @input="onSelectChange(field, $event)" v-model="fieldValues[field.hash]" @focusout="handleFocusOut(field)" />
          </template>
          <template
            v-else-if="showField(field) && ([$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE].includes(field.type_id)  && field.related_parent_hash !== null)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span></label>
            <!-- <span>
              {{  JSON.stringify(field.options[fieldValues[field.related_parent_hash].value]) }}
            </span> -->
            <select-field
              multiple
              :isDisabled="isFieldDisabled(field, allDisabledFields, action)"
              :options="field.related_parent_hash ? fieldOptions[field.hash] : getDependentOptions(field)"
              @input="onSelectChange(field, $event)"
              v-model="fieldValues[field.hash]"
              @focusout="handleFocusOut(field)"
              :quick-create="true"/>
          </template>

          <!-- :isDisabled="isFieldDisabled(field, allDisabledFields, action)"  -->
          <template
            v-else-if="showField(field) && ([$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE].includes(field.type_id) && field.related_parent_hash === null)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <select-field
              multiple
              :options="field.related_parent_hash ? fieldOptions[field.hash] : field.options"
              v-model="fieldValues[field.hash]"
              @input="onSelectChange(field, $event)"
              @focusout="handleFocusOut(field)" />
          </template>

          <!-- <template
            v-else-if="showField(field) && ([$FIELD_TYPES.RELATED_TO_A_MODULE].includes(field.type_id) && field.related_parent_hash !== null)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} </label>
            <select-field :isDisabled="isFieldDisabled(field, allDisabledFields, action)" @focusout="handleFocusOut(field)"
              :options="getDependentOptions(field)"
              v-model="fieldValues[field.hash]" />
          </template> -->

          <template v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.BOOLEAN)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <boolean-field :isDisabled="isFieldDisabled(field, allDisabledFields, action)" @focusout="handleFocusOut(field)"
              v-model="fieldValues[field.hash]" />
<!-- @input="onFieldChange($event, field)" -->
          </template>

          <template v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.DOCUMENT)">
            <document-field :field="field" :viewMode="action === 'view'" :disabled="isFieldDisabled(field, allDisabledFields, action)" @focusout="handleFocusOut(field)"
              @onDelete="onDeleteDocument($event, field.hash)" @onSuccess="onSuccessDocument($event, field.hash)"
              @onOpenDocument="openDocument($event, fieldValues[field.hash])" />
          </template>

          <template
            v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.PERCENTAGE || field.type_id === $FIELD_TYPES.DECIMAL || field.type_id === $FIELD_TYPES.CURRENCY)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <decimal-field v-model="fieldValues[field.hash]" @focusout="handleFocusOut(field)"
              :isDisabled="isFieldDisabled(field, allDisabledFields, action)" :placeholder="field.placeholder"
              :type="field.secret && !fieldSecrets[field.hash]['visible'] ? 'password' : 'tel'"
              :moneyAttributes="{ decimal: ',', thousands: '.', prefix: '', suffix: '', precision: field.decimals || 2, masked: false }" />
          </template>

          <!-- @focusout="onFieldChange($event, field)" -->
          <template v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.INTEGER)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <mask-field
            @focusout="handleFocusOut(field)"
            :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'text'"
            :placeholder="field.placeholder"
            :disabled="isFieldDisabled(field, allDisabledFields, action)"
            v-model="fieldValues[field.hash]"
            :mask="'##########'"
            :maxlength="field.length || 524288"
            />
          </template>

          <template v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.DATE)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <date-field :placeholder="field.placeholder" @focusout="handleFocusOut(field)" :isDisabled="isFieldDisabled(field, allDisabledFields, action)"
              v-model="fieldValues[field.hash]" :minValue="field.min_value" :maxValue="field.max_value" :allowPastDates="field.allow_past_dates" />
          </template>

          <template v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.DATETIME)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <date-field @focusout="handleFocusOut(field)" componentType="datetime" :placeholder="field.placeholder"
              :isDisabled="isFieldDisabled(field, allDisabledFields, action)" v-model="fieldValues[field.hash]"
              :minValue="field.min_value" :maxValue="field.max_value" :allowPastDates="field.allow_past_dates" />
          </template>

          <template v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.MULTIPLE_DATE)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <date-field @focusout="handleFocusOut(field)" componentType="multiple_date" :placeholder="field.placeholder"
              :isDisabled="isFieldDisabled(field, allDisabledFields, action)" v-model="fieldValues[field.hash]"
              :minValue="field.min_value" :maxValue="field.max_value" :allowPastDates="field.allow_past_dates" />
          </template>

          <template v-else-if="showField(field) && (field.type_id === $FIELD_TYPES.TEXTAREA)">
            <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory && field._block_title !== 'Campos do Sistema'" style="color: red;"> *</span> </label>
            <div class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08)!important;">
              <textarea
                :disabled="isFieldDisabled(field, allDisabledFields, action)"
                style="height: 150px!important;"
                class="vs-textarea"
                v-model="fieldValues[field.hash]"
                :name="field.hash"
                :placeholder="field.placeholder"
                @focusout="handleFocusOut(field)"
                :maxlength="field.length ? field.length : 1000000">
              </textarea>
            </div>
          </template>
        </div>

      </div>
      <div class="vx-row" v-if="action !== 'view'">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="saveChanges">Salvar Alterações</vs-button>
            <!-- <vs-button class="ml-4 mt-2" type="border" color="danger"
              @click="$router.push($route.params.rowHash ? '/modules/' + $route.params.moduleHash : '/modules/view/' + $route.params.moduleHash)">Cancelar</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" icon-pack="feather" icon="icon-corner-up-left"
              @click="$router.go(-1)">Voltar</vs-button> -->
          </div>
        </div>
      </div>
    </vs-popup>

  </div>

</template>

<script>
import { watch, onMounted, onBeforeUnmount } from 'vue';
import TextField from '../custom-fields/TextField.vue'
import DecimalField from '../custom-fields/DecimalField.vue'
import SelectField from '../custom-fields/SelectField.vue'
import DocumentField from '../custom-fields/DocumentField.vue'
import DateField from '../custom-fields/DateField.vue'
import MaskField from '../custom-fields/MaskField.vue'
import { isFieldDisabled, NORMAL_FIELDS, formatFieldValues, formatFieldValueToComponent } from '../../customFormHelpers'
import { performFetch } from '../../helpers'
import BooleanField from '../custom-fields/BooleanField.vue';


export default {
  components: {
    TextField,
    DecimalField,
    SelectField,
    DocumentField,
    DateField,
    MaskField,
    BooleanField
  },
  data() {
    return {
      popUpActive: this.modalVisible,
      NORMAL_FIELDS,
      fieldValues: {},
      fieldTypes: {},
      fieldSecrets: {},
      dataFieldPayload: {},
      fieldsByHash: {},
      childFields: {},
      childrenOptions: {},
      fieldOptions: {},
      dependentOptions: {},
      delegatorDisabledFields: [],
      fieldData: {},
      mandatoryFields: []
    };
  },
  props: {
    openModal: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Array,
      default: []
    },
    disabledFields: {
      type: Array,
      default: []
    },
    action: {
      type: String,
      default: 'view'
    },
    rowHash: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Form'
    },
    delegatorUrl: {
      type: String,
      default: ''
    },
    moduleHash: {
      type: String,
      default: ''
    },
    parentRowHash: {
      type: String,
      default: ''
    },
  },
  watch: {
    openModal: {
      immediate: true,
      async handler(val) {

        while(Object.keys(this.fieldValues).length === 0) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        if(val) {
          await this.onModalOpen();
        }
        // this.popUpActive = val;
        // console.log('MODAL: ', val);
      }
    },
    formData: {
      immediate: true,
      async handler(val) {
        this.buildfieldValues();
        await this.onModalOpen();
        await this.hydrateDependentOptions();
      }
    },
    action: {
      immediate: true,
      handler(val) {
        // console.log('MODAL ACTION: ', val);
      }
    }
  },
  computed: {
    allDisabledFields() {
      return this.disabledFields.concat(this.delegatorDisabledFields);
    },
    columnSize() {
      const columns = this.organizedFields[0].length
      switch (columns) {
        case 1:
          return 'w-full'
        case 2:
          return 'w-1/2'
        case 3:
          return 'w-1/3'
      }
      // console.log(columns)
      // return 'md-1/2'
    },
    modalActive: {
      get() {
        return this.openModal;
      },
      set(value) {
        this.$emit('onClose', value); // Emite para o pai quando o modal fecha
      }
    },
    organizedFields() {
      const fields = this.formData;
      const total = fields.length;
      let columns;

      // Se 6 ou menos, usa 1 coluna (cada field em uma linha)
      if (total <= 6) {
        columns = 1;
      } else if (total > 6 && total <= 12) {
        columns = 2;
      }
      else {
        // Começa com 2 colunas e aumenta se as linhas ficarem mais que 6
        columns = 3;
        while (Math.ceil(total / columns) > 6) {
          columns++;
        }
      }

      const numRows = Math.ceil(total / columns);
      const grid = [];

      // Preenche a grade linha a linha (row-first)
      for (let row = 0; row < numRows; row++) {
        const rowFields = [];
        for (let col = 0; col < columns; col++) {
          // Calcula o índice considerando que estamos preenchendo linha a linha
          const index = row * columns + col;
          if (index < total) {
            rowFields.push(fields[index]);
          }
        }
        grid.push(rowFields);
      }

      //console.log('Organized Fields: ', grid);

      return grid;
    }
  },
  methods: {
    showField(field) {
      // field.related_picklist_field_hash !== null  fieldValues[field.related_picklist_field_hash] === field.related_picklist_item_hash

      if (field.related_picklist_field_hash !== null && field.related_picklist_item_hash !== null) {
        if(this.fieldValues[field.related_picklist_field_hash] && this.fieldValues[field.related_picklist_field_hash].value === field.related_picklist_item_hash) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
      //  else if(field.related_parent_hash === null && field.related_picklist_field_hash === null) {
      //   return true;
      // }

      // return true;
    },
    async onModalOpen() {
      if(this.$store.state.auth.delegator_url) {
        try {
          const response = await fetch(this.$store.state.auth.delegator_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              command: "quick_create_modal_opened",
              parent_row_hash: this.parentRowHash,
              row_hash: this.rowHash,
              field_values: this.fieldValues,
              module_token: this.moduleHash,
              application_token: this.$store.state.auth.app_token
            })
          })

          const responsePayload = await response.json();

          if(responsePayload && Object.keys(responsePayload).length > 0) {
            this.handleDelegatorResponse(responsePayload)
          } else {
            // console.log('delegator empty response');
          }
        } catch (error) {
          console.error('Error calling delegator:', error);
        }

      }
    },
    async handleFocusOut(field) {
      // console.log('Focus Out: ', field.title);
      if(field.call_api) {
        await this.callDelegator(field);

        // this.handleDelegatorResponse(response)
      }
      // this.$emit("onTextFieldFocusOut");
    },
    async callDelegator(field) {

      const response = await fetch(this.$store.state.auth.delegator_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              command: "get_field_data",
              row_hash: this.rowHash,
              module_token: this.moduleHash,
              application_token: this.$store.state.auth.app_token,
              parameters: {
                field: {
                  hash: field.hash,
                  payload: this.fieldValues[field.hash],
                },
                row_payload: this.fieldValues,
              }
            }
          )
        })

      const responsePayload = await response.json();
      this.handleDelegatorResponse(responsePayload);
      // this.$emit("onTextFieldClick");
    },
    handleDelegatorResponse(response) {
      // console.log('Delegator response: ', response);
      // this.fieldValues = response;

      for(const [key, value] of Object.entries(response.payload)) {
        // console.log(this.fieldTypes[key], key, value);
        if(this.fieldValues.hasOwnProperty(key)) {
          switch(this.fieldTypes[key]) {

            case this.$FIELD_TYPES.RELATED_TO_A_MODULE:
              const option = this.fieldOptions[key].find(option => option.value === value)
              if(option) {
                this.$set(this.fieldValues, key, option);
              }
              break;

            case this.$FIELD_TYPES.STRING:
              this.$set(this.fieldValues, key, value);
              break;

            case this.$FIELD_TYPES.DECIMAL:
              // console.log('here')
              // console.log(parseFloat(value))
              this.$set(this.fieldValues, key, parseFloat(value))
              break;

              default:
                break;

          }
        }
      }

      if(response.disabled_fields) {
        this.delegatorDisabledFields = JSON.parse(JSON.stringify(response.disabled_fields))
      }

    },
    onSelectChange(field, value) {
      if (Array.isArray(field.field_children)) {
        for (const child of field.field_children) {
          const childType = this.fieldTypes[child];
          this.fieldValues[child] = childType === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE ? [] : null;
        }
      }
      const fieldType = this.fieldTypes[field.hash];
      if ([this.$FIELD_TYPES.RELATED_TO_A_MODULE, this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE].includes(fieldType)) {
        const nextValue = value !== undefined ? value : this.fieldValues[field.hash];
        this.relatedModuleFieldChange(field.hash, nextValue);
      }
    },
    chunkArray(array) {
      return array.reduce((result, item, index) => {
        const chunkIndex = Math.floor(index / chunkSize);
        if (!result[chunkIndex]) {
          result[chunkIndex] = [];
        }
        result[chunkIndex].push(item);
        return result;
      }, []);
    },
    buildfieldValues() {
      this.mandatoryFields = [];
      this.formData.forEach(field => {
        this.$set(this.fieldData, field.hash, field);
        this.$set(this.fieldsByHash, field.hash, field);
        const formattedValue = formatFieldValueToComponent(field);
        this.$set(this.fieldValues, field.hash, formattedValue);
        this.$set(this.fieldTypes, field.hash, field.type_id);
        this.$set(this.fieldSecrets, field.hash, { visible: false });
        this.$set(this.dataFieldPayload, field.hash, field.payload);
        if (field.type_id === this.$FIELD_TYPES.RELATED_TO_A_MODULE && field.related_parent_hash === null) {
          const needsFallback = formattedValue === null || (typeof formattedValue === 'object' && Object.keys(formattedValue).length === 0);
          if (field.payload !== null && needsFallback) {
            const label = field.payload_label ? field.payload_label : `${field.payload}`;
            this.$set(this.fieldValues, field.hash, { value: field.payload, label });
          }
        }
        if (field.type_id === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE && field.related_parent_hash === null) {
          const needsFallback = !Array.isArray(formattedValue) || formattedValue.length === 0;
          if (Array.isArray(field.payload) && field.payload.length > 0 && needsFallback) {
            const labels = Array.isArray(field.payload_label) ? field.payload_label : [];
            const fallbackSelections = field.payload.map((value, index) => ({
              value,
              label: labels[index] || `${value}`
            }));
            this.$set(this.fieldValues, field.hash, fallbackSelections);
          }
        }
        if (Array.isArray(field.field_children)) {
          this.$set(this.childFields, field.hash, field.field_children);
        }
        if(field.options && field.options !== null && field.options !== undefined) {
          this.$set(this.fieldOptions, field.hash, field.options);
        }

        if (field.mandatory) {
          if (!this.mandatoryFields.some(item => item.hash === field.hash)) {
            this.mandatoryFields.push(field);
          }
        }

        // if(Array.isArray(field.field_children)) {
        //   for(const child of field.field_children) {
        //     this.$set(this.childrenOptions, child, field)
        //   }
        // }
      });
    },
    async hydrateDependentOptions() {
      const dependentFields = this.formData.filter(field =>
        field.related_parent_hash !== null &&
        [this.$FIELD_TYPES.RELATED_TO_A_MODULE, this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE].includes(field.type_id)
      );

      for (const field of dependentFields) {
        const parentValue = this.fieldValues[field.related_parent_hash];
        if (parentValue) {
          await this.relatedModuleFieldChange(field.related_parent_hash, parentValue, null, field.hash);
        }
      }
    },
    getDependentOptions(field) {
      const cached = this.dependentOptions[field.hash];
      if (Array.isArray(cached) && cached.length > 0) {
        return cached;
      }

      const options = field.options;
      if (Array.isArray(options)) {
        return options;
      }

      const parentValue = this.fieldValues[field.related_parent_hash];
      const parentKey = parentValue && parentValue.value !== undefined ? parentValue.value : null;
      if (options && parentKey !== null && options[parentKey]) {
        return options[parentKey];
      }

      return [];
    },
    getLocalDependentOptions(childHash, parentValue) {
      const field = this.fieldsByHash[childHash];
      if (!field || !field.options) {
        return [];
      }

      if (Array.isArray(field.options)) {
        return field.options;
      }

      if (parentValue !== null && parentValue !== undefined && field.options[parentValue]) {
        return field.options[parentValue];
      }

      return [];
    },
    async relatedModuleFieldChange(fieldHash, selection, defaultOption = null, ownerHash = null) {
      console.log('relatedModuleFieldChange: ', fieldHash, selection, defaultOption, ownerHash);
      const childFields = ownerHash !== null ? [ownerHash] : (this.childFields[fieldHash] || []);
      if (!Array.isArray(childFields) || childFields.length === 0) {
        return;
      }

      const isEditOrView = this.action !== 'add';
      const parentSelections = Array.isArray(selection) ? selection : (selection ? [selection] : []);
      const parentValues = parentSelections
        .map(item => (item && item.value !== undefined ? item.value : item))
        .filter(Boolean);

      const clearChild = (childHash) => {
        const childTypeId = this.fieldTypes[childHash];
        this.$set(this.dependentOptions, childHash, []);
        this.$set(this.fieldValues, childHash, childTypeId === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE ? [] : {});
      };

      for (const childHash of childFields) {
        if (parentValues.length === 0) {
          const payloadValue = this.dataFieldPayload[childHash];
          const currentValue = this.fieldValues[childHash];
          const hasSavedValue = Array.isArray(payloadValue)
            ? payloadValue.length > 0
            : payloadValue !== null && payloadValue !== undefined && payloadValue !== '';
          const hasCurrentValue = Array.isArray(currentValue)
            ? currentValue.length > 0
            : currentValue && Object.keys(currentValue).length > 0;
          if (!(isEditOrView && (hasSavedValue || hasCurrentValue))) {
            clearChild(childHash);
          }
          continue;
        }

        let aggregatedOptions = [];
        for (const parentValue of parentValues) {
          let options = await this.fetchDependentChildOptions(childHash, parentValue);
          if (Array.isArray(options) && options.length > 0) {
            aggregatedOptions = aggregatedOptions.concat(options);
          }
        }

        const normalizedOptions = aggregatedOptions.map(option => ({ value: option.value, label: option.label, label_en: option.label_en }));
        console.log('normalizedOptions: ', normalizedOptions);
        this.$set(this.fieldOptions, childHash, normalizedOptions);
        await this.$nextTick();

        const payload = this.fieldData[childHash] ? this.fieldData[childHash].payload : null;
        const payloadValues = Array.isArray(payload)
          ? payload
          : (payload !== null && payload !== undefined ? [payload] : []);

        if (this.fieldTypes[childHash] === this.$FIELD_TYPES.RELATED_TO_A_MODULE) {
          console.log('payloadValues: ', payloadValues);
          const match = normalizedOptions.find(option => payloadValues.includes(option.value));
          console.log('match: ', match);
          this.$set(this.fieldValues, childHash, match || null);
        } else {
          const matches = normalizedOptions.filter(option => payloadValues.includes(option.value));
          this.$set(this.fieldValues, childHash, matches);
        }

        // console.log(this.fieldValues[childHash]);




      }
    },
    async fetchDependentChildOptions(childHash, parentHash) {
      this.$vs.loading({ type: 'default' });
      try {
        const response = await performFetch(this.$store.state.auth.api_url, {
          command: 'get_related_module_options',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            module_token: this.moduleHash,
            session_token: this.$store.state.auth.token,
            field_hash: childHash,
            parent_hash: parentHash
          }
        });

        this.$vs.loading.close();

        if (response.status === 200) {
          const responseData = await response.json();
          if (responseData && responseData.payload && Array.isArray(responseData.payload.options)) {
            return responseData.payload.options.map(option => ({
              value: option.value,
              label: option.label,
              label_en: option.label_en,
              selected: option.selected
            }));
          }
        }
      } catch (error) {
        console.error('Error fetching dependent options', error);
      }
      return [];
    },
    isFieldDisabled,
    closeModal() {
      // this.modalActive = false;
    },
    isSystemBlockField(field) {
      return field._block_title === 'Campos do Sistema';
    },
    validateForm() {
      let hasFieldMandatory = false;

      for (const item of this.mandatoryFields) {
        if (!this.showField(item)) continue;
        if (this.isSystemBlockField(item)) continue;

        const value = this.fieldValues[item.hash];
        const fieldType = this.fieldTypes[item.hash];
        let isEmpty = false;

        if (fieldType === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE && Array.isArray(value) && value.length === 0) {
          isEmpty = true;
        } else if (typeof value === 'object' && value !== null) {
          if (JSON.stringify(value) === '{}') {
            isEmpty = true;
          } else if (value.hasOwnProperty('value') && (value.value === 0 || value.value === null || value.value === undefined)) {
            isEmpty = true;
          }
        } else if ([this.$FIELD_TYPES.DECIMAL, this.$FIELD_TYPES.CURRENCY, this.$FIELD_TYPES.PERCENTAGE].includes(fieldType)) {
          if (value === 0 || value === null || value === undefined || value === '') {
            isEmpty = true;
          }
        } else if (value === '' || value === null || value === undefined) {
          isEmpty = true;
        }

        if (isEmpty) {
          this.$vs.notify({
            title: 'Atenção!',
            text: `O campo ${item.title} é obrigatório`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 5000
          });
          hasFieldMandatory = true;
        }
      }

      return !hasFieldMandatory;
    },
    saveChanges() {
      if (!this.validateForm()) return;
      const formattedFieldValues = formatFieldValues(this.fieldValues, this.fieldTypes);
      this.$emit('onSave', { data: formattedFieldValues, rowHash: this.rowHash });
    },
    handleKeydown(event) {
      if (event.key === 'Enter' && this.modalActive) {
        this.saveChanges();
      }
    },
    onSuccessDocument(event, fieldHash) {
      const responseData = JSON.parse(event.srcElement.response)

      // const documentRelatedFieldName = this.documentFieldModel.hasOwnProperty(fieldHash) ? this.documentFieldModel[fieldHash] : null

      // if (documentRelatedFieldName !== null) {
      //   this.fieldValues[documentRelatedFieldName] = responseData.file_name
      // }

      this.fieldValues[fieldHash] = responseData.file_url
    },
    onDeleteDocument(event, fieldHash) {
      this.fieldValues[fieldHash] = null
    },
    openDocument(event, documentUrl) {
      if (event.target.textContent !== 'clear') {
        window.open(documentUrl, '_blank')
      }
    },
  },
  created() {
    console.log('quick create modal rendered');
    // this.buildfieldValues();
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }
};

</script>
